import { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  label: string;
};

export const Tooltip: FC<Props> = ({ children, label }) => {
  return (
    <div className="tooltip" title={label}>
      {children}
    </div>
  );
};
